import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

import { AlmaLink } from '../alma-link';
import { PortableText } from '../portableText';
import * as styles from './banner-variant.module.css';

export const BannerVariant = ({
	_rawBannerCopy,
	bannerBgColor,
	bannerBorderColor,
	bannerCTA,
	cardStackPadding,
	fadeEffects,
	image,
	imageWidth,
	textColor,
}) => {
	const bannerVariantImage = getImage(image?.asset);

	// content padding
	const cardStackPaddingHorizontal = cardStackPadding?.paddingHorizontal;
	const cardStackPaddingVertical = cardStackPadding?.paddingVertical;

	// fade effects
	const enableFadeEffect = fadeEffects?.enableFadeEffect;
	const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

	return (
		<div
			className={classNames(
				bannerBgColor && `b${bannerBgColor}`,
				bannerBorderColor &&
					`bo${bannerBorderColor} ${styles.hasBorder}`,
				cardStackPaddingHorizontal,
				cardStackPaddingVertical === 'padding-top-0 padding-bottom-0' &&
					styles.center,
				cardStackPaddingVertical,
				styles.bannerContainer
			)}
		>
			<div
				className={classNames(
					enableFadeEffect && 'reveal',
					fadeEffectDirection && fadeEffectDirection,
					styles.bannerContent
				)}
			>
				{bannerVariantImage && (
					<div style={{ maxWidth: `${imageWidth}px` }}>
						<GatsbyImage
							alt={image?.alt || ''}
							image={bannerVariantImage}
							className={styles.image}
						/>
					</div>
				)}
				{_rawBannerCopy && (
					<div
						className={classNames(
							styles.bannerVariantBannerContainer,
							textColor
						)}
					>
						<PortableText blocks={_rawBannerCopy} />
					</div>
				)}
			</div>
			{bannerCTA?.title && <AlmaLink cta={bannerCTA} />}
		</div>
	);
};
